(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('category-scroller')) {
    customElements.define(
      'category-scroller',
      class CategoryScroller extends HTMLElement {
        connectedCallback() {
          this.list = this.querySelector('.category-row__list');
          this.buttons = this.querySelectorAll('.category-row__nav');
          if (!this.list) return;
          this.update = this.update.bind(this);
          this.buttons.forEach((button) => button.addEventListener('click', () => this.scrollByPage(Number(button.dataset.direction))));
          this.list.addEventListener('scroll', this.update, { passive: true });
          this.resizeObserver = new ResizeObserver(this.update);
          this.resizeObserver.observe(this.list);
          this.update();
        }

        disconnectedCallback() {
          if (this.resizeObserver) this.resizeObserver.disconnect();
        }

        scrollByPage(direction) {
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.list.scrollBy({ left: direction * this.list.clientWidth * 0.85, behavior: reduceMotion ? 'auto' : 'smooth' });
        }

        update() {
          const maxScroll = this.list.scrollWidth - this.list.clientWidth;
          const media = this.list.querySelector('.category-row__media');
          if (media) this.style.setProperty('--category-media-height', `${media.offsetHeight}px`);
          this.classList.toggle('is-scrollable', maxScroll > 2);
          const [prev, next] = this.buttons;
          if (prev) prev.disabled = this.list.scrollLeft <= 2;
          if (next) next.disabled = this.list.scrollLeft >= maxScroll - 2;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cctv-deals-week"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cctv-deals-week')) {
    const EXPIRY_PATTERN = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(Z|[+-]\d{2}:\d{2})$/;

    customElements.define(
      'cctv-deals-week',
      class CctvDealsWeek extends HTMLElement {
        connectedCallback() {
          this.abortController = new AbortController();
          this.setUpCountdown();
          this.setUpCarousel();
        }

        disconnectedCallback() {
          clearInterval(this.interval);
          this.interval = null;
          this.abortController?.abort();
        }

        setUpCountdown() {
          const expiry = (this.dataset.expiry || '').trim();
          if (!EXPIRY_PATTERN.test(expiry)) return;
          const end = Date.parse(expiry);
          if (Number.isNaN(end)) return;

          this.end = end;
          this.units = {};
          this.querySelectorAll('[data-unit]').forEach((element) => {
            this.units[element.dataset.unit] = element;
          });
          clearInterval(this.interval);
          if (this.tick()) this.interval = setInterval(() => this.tick(), 1000);
        }

        tick() {
          const remaining = Math.ceil((this.end - Date.now()) / 1000);
          if (remaining <= 0) {
            clearInterval(this.interval);
            this.interval = null;
            this.showEnded();
            return false;
          }
          const values = {
            days: Math.floor(remaining / 86400),
            hours: Math.floor((remaining % 86400) / 3600),
            minutes: Math.floor((remaining % 3600) / 60),
            seconds: remaining % 60,
          };
          Object.entries(values).forEach(([unit, value]) => {
            const text = String(value).padStart(2, '0');
            if (this.units[unit] && this.units[unit].textContent !== text) this.units[unit].textContent = text;
          });
          return true;
        }

        showEnded() {
          this.dataset.state = 'ended';
          this.querySelector('[data-deals-badge]')?.remove();
          this.querySelector('[data-deals-countdown]')?.remove();
          this.querySelector('[data-deals-ended]')?.removeAttribute('hidden');
        }

        setUpCarousel() {
          const viewport = this.querySelector('[data-deals-viewport]');
          const prev = this.querySelector('[data-deals-prev]');
          const next = this.querySelector('[data-deals-next]');
          if (!viewport || !prev || !next) return;

          const { signal } = this.abortController;
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
          const update = () => {
            const maxScroll = viewport.scrollWidth - viewport.clientWidth;
            prev.disabled = viewport.scrollLeft <= 2;
            next.disabled = viewport.scrollLeft >= maxScroll - 2;
          };
          const step = (direction) => {
            const slide = viewport.querySelector('.deals-week__slide');
            const distance = slide ? slide.getBoundingClientRect().width + 12 : viewport.clientWidth;
            viewport.scrollBy({ left: direction * distance, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
          };

          prev.addEventListener('click', () => step(-1), { signal });
          next.addEventListener('click', () => step(1), { signal });
          viewport.addEventListener('scroll', update, { passive: true, signal });
          window.addEventListener('resize', update, { signal });
          update();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["curated-nvr-ip-cameras"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('curated-products')) {
    customElements.define(
      'curated-products',
      class CuratedProducts extends HTMLElement {
        connectedCallback() {
          this.tabs = [...this.querySelectorAll('[role="tab"]')];
          this.items = [...this.querySelectorAll('.curated-nvr__item')];
          this.panel = this.querySelector('[role="tabpanel"]');
          this.limit = parseInt(this.dataset.limit, 10) || 4;
          if (!this.tabs.length) return;

          this.storageKey = `curated-products-filter-${this.dataset.sectionId}`;
          this.tabs.forEach((tab) => {
            tab.addEventListener('click', () => this.select(tab, true));
            tab.addEventListener('keydown', (event) => this.onKeydown(event));
          });

          let saved = null;
          try {
            saved = window.sessionStorage.getItem(this.storageKey);
          } catch (error) {
            saved = null;
          }
          const savedTab = this.tabs.find((tab) => tab.dataset.filter === saved);
          if (savedTab) this.select(savedTab, false);
        }

        onKeydown(event) {
          const index = this.tabs.indexOf(event.currentTarget);
          let next = null;
          if (event.key === 'ArrowRight') next = this.tabs[(index + 1) % this.tabs.length];
          if (event.key === 'ArrowLeft') next = this.tabs[(index - 1 + this.tabs.length) % this.tabs.length];
          if (event.key === 'Home') next = this.tabs[0];
          if (event.key === 'End') next = this.tabs[this.tabs.length - 1];
          if (!next) return;
          event.preventDefault();
          this.select(next, true);
          next.focus();
        }

        select(selectedTab, remember) {
          const filter = selectedTab.dataset.filter;
          this.tabs.forEach((tab) => {
            const active = tab === selectedTab;
            tab.setAttribute('aria-selected', active ? 'true' : 'false');
            tab.tabIndex = active ? 0 : -1;
          });
          if (this.panel) this.panel.setAttribute('aria-labelledby', selectedTab.id);

          let shown = 0;
          this.items.forEach((item) => {
            const matches = filter === 'all' || item.dataset.filter.split(' ').includes(filter);
            const visible = matches && shown < this.limit;
            if (visible) shown += 1;
            item.hidden = !visible;
          });

          if (!remember) return;
          try {
            window.sessionStorage.setItem(this.storageKey, filter);
          } catch (error) {
            // The selection still applies for this page view without storage.
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  // Footer newsletter: block double submits while Shopify processes the signup.
  // The form still posts natively, so success and errors come from Shopify's response.
  // Listens on window so it runs after Shopify's bot-protection handler; when that handler has
  // taken over the submit (to show a challenge), this steps aside and leaves the button usable.
  window.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.classList.contains('cctv-footer__form')) return;

    if (form.dataset.submitting === 'true') {
      event.preventDefault();
      return;
    }

    if (event.defaultPrevented) return;

    form.dataset.submitting = 'true';
    form.setAttribute('aria-busy', 'true');
    const button = form.querySelector('.cctv-footer__subscribe');
    if (button) {
      button.dataset.idleLabel = button.textContent;
      button.textContent = button.dataset.loadingLabel || button.textContent;
      button.setAttribute('aria-disabled', 'true');
    }
  });

  // Restore the button if the visitor comes back to this page from the browser cache
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    document.querySelectorAll('.cctv-footer__form[data-submitting="true"]').forEach((form) => {
      delete form.dataset.submitting;
      form.removeAttribute('aria-busy');
      const button = form.querySelector('.cctv-footer__subscribe');
      if (!button) return;
      if (button.dataset.idleLabel) button.textContent = button.dataset.idleLabel;
      button.removeAttribute('aria-disabled');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      this.resizeObserver = new ResizeObserver(this.setHeaderHeight);
      this.resizeObserver.observe(this.header);
      const topBar = document.querySelector('.section-top-bar');
      if (topBar) this.resizeObserver.observe(topBar);

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      const root = document.documentElement.style;
      root.setProperty('--header-height', `${this.header.offsetHeight}px`);

      // Always-sticky mode keeps the trust bar and the header together at the top of the viewport.
      // The header sticks right under the trust bar, and the combined height is shared so anchors
      // and other sticky elements stop below the header instead of behind it.
      const topBar = this.headerIsAlwaysSticky ? document.querySelector('.section-top-bar') : null;
      const topBarHeight = topBar ? topBar.offsetHeight : 0;
      root.setProperty('--top-bar-height', `${topBarHeight}px`);
      root.setProperty('--sticky-header-offset', `${this.headerIsAlwaysSticky ? topBarHeight + this.header.offsetHeight : 0}px`);
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-bought-together"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-bought-together')) {
    customElements.define(
      'product-bought-together',
      class ProductBoughtTogether extends HTMLElement {
        connectedCallback() {
          this.items = Array.from(this.querySelectorAll('[data-fbt-item]'));
          this.submitButton = this.querySelector('[data-fbt-submit]');
          this.errorMessage = this.querySelector('[data-fbt-error]');

          this.addEventListener('change', (event) => {
            const item = event.target.closest('[data-fbt-item]');
            if (!item) return;
            if (event.target.matches('[data-fbt-variant]')) this.applySelectedOption(item);
            this.update();
          });
          this.submitButton.addEventListener('click', () => this.addToCart());

          this.items.forEach((item) => {
            if (item.querySelector('[data-fbt-variant]')) this.applySelectedOption(item);
          });
          this.subscribeToVariantChanges();
          this.update();
        }

        disconnectedCallback() {
          if (this.unsubscribe) this.unsubscribe();
        }

        subscribeToVariantChanges() {
          const subscribeNow = () => {
            if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
            this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
              const variant = event.data.variant;
              const productId = event.data.html?.querySelector?.('product-info')?.dataset.productId;
              if (productId && productId !== this.dataset.mainProductId) return;
              const mainItem = this.querySelector('[data-fbt-item][data-main]');
              if (!variant || !mainItem) return;
              this.setItemVariant(mainItem, {
                id: variant.id,
                price: variant.price,
                compare: variant.compare_at_price || 0,
                available: variant.available,
              });
              this.update();
            });
          };

          if (typeof subscribe === 'function') {
            subscribeNow();
          } else if (document.readyState !== 'complete') {
            document.addEventListener('DOMContentLoaded', subscribeNow, { once: true });
          }
        }

        applySelectedOption(item) {
          const option = item.querySelector('[data-fbt-variant]').selectedOptions[0];
          if (!option) return;
          this.setItemVariant(item, {
            id: option.value,
            price: Number(option.dataset.price),
            compare: Number(option.dataset.compare),
            available: !option.disabled,
          });
        }

        setItemVariant(item, variant) {
          item.dataset.variantId = variant.id;
          item.dataset.price = variant.price;
          item.dataset.compare = variant.compare;
          item.dataset.available = variant.available ? 'true' : 'false';

          const checkbox = item.querySelector('[data-fbt-checkbox]');
          checkbox.disabled = !variant.available;
          if (!variant.available) checkbox.checked = false;

          const price = item.querySelector('[data-fbt-price]');
          const compare = item.querySelector('[data-fbt-compare]');
          if (price) price.textContent = this.formatMoney(variant.price);
          if (compare) {
            const showCompare = variant.compare > variant.price;
            compare.hidden = !showCompare;
            compare.textContent = showCompare ? this.formatMoney(variant.compare) : '';
          }
        }

        selectedItems() {
          return this.items.filter(
            (item) => item.dataset.available === 'true' && item.querySelector('[data-fbt-checkbox]').checked
          );
        }

        update() {
          const selected = this.selectedItems();
          let total = 0;
          let compareTotal = 0;
          selected.forEach((item) => {
            const price = Number(item.dataset.price) || 0;
            const compare = Number(item.dataset.compare) || 0;
            total += price;
            compareTotal += compare > price ? compare : price;
          });

          this.querySelector('[data-fbt-total]').textContent = this.formatMoney(total);

          const compareElement = this.querySelector('[data-fbt-total-compare]');
          const savingsElement = this.querySelector('[data-fbt-savings]');
          const hasSavings = selected.length > 0 && compareTotal > total;
          compareElement.hidden = !hasSavings;
          savingsElement.hidden = !hasSavings;
          compareElement.textContent = hasSavings ? this.formatMoney(compareTotal) : '';
          savingsElement.textContent = hasSavings
            ? window.cctvFbtStrings.savings.replace('[amount]', this.formatMoney(compareTotal - total))
            : '';

          this.querySelector('[data-fbt-count]').textContent = window.cctvFbtStrings.count
            .replace('[count]', selected.length)
            .replace('[total]', this.items.length);
          this.submitButton.disabled = selected.length === 0;
        }

        addToCart() {
          const selected = this.selectedItems();
          if (selected.length === 0 || this.submitButton.getAttribute('aria-disabled') === 'true') return;

          const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          const body = {
            items: selected.map((item) => ({ id: Number(item.dataset.variantId), quantity: 1 })),
          };
          if (cart) {
            body.sections = cart.getSectionsToRender().map((section) => section.id);
            body.sections_url = window.location.pathname;
            cart.setActiveElement(this.submitButton);
          }

          this.errorMessage.hidden = true;
          this.submitButton.setAttribute('aria-disabled', 'true');
          this.submitButton.classList.add('loading');
          this.submitButton.querySelector('.loading__spinner')?.classList.remove('hidden');

          const config = fetchConfig();
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          config.body = JSON.stringify(body);

          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                this.errorMessage.textContent = response.description || response.message;
                this.errorMessage.hidden = false;
                return;
              }

              if (!cart) {
                window.location = window.routes.cart_url;
                return;
              }

              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-bought-together', cartData: response });
              cart.classList.remove('is-empty');
              if (cart.tagName === 'CART-NOTIFICATION') {
                cart.renderContents({ ...response, key: response.items[0].key });
              } else {
                cart.renderContents(response);
              }
            })
            .catch((error) => {
              console.error(error);
              this.errorMessage.textContent = window.cctvFbtStrings.error;
              this.errorMessage.hidden = false;
            })
            .finally(() => {
              this.submitButton.removeAttribute('aria-disabled');
              this.submitButton.classList.remove('loading');
              this.submitButton.querySelector('.loading__spinner')?.classList.add('hidden');
            });
        }

        formatMoney(cents) {
          const format = this.dataset.moneyFormat || '[amount]';
          const group = (value, precision, thousands, decimal) => {
            const [whole, fraction] = (value / 100).toFixed(precision).split('.');
            const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
            return fraction ? `${grouped}${decimal}${fraction}` : grouped;
          };
          const formatters = {
            amount: () => group(cents, 2, ',', '.'),
            amount_no_decimals: () => group(cents, 0, ',', '.'),
            amount_with_comma_separator: () => group(cents, 2, '.', ','),
            amount_no_decimals_with_comma_separator: () => group(cents, 0, '.', ','),
            amount_with_space_separator: () => group(cents, 2, ' ', ','),
            amount_no_decimals_with_space_separator: () => group(cents, 0, ' ', ','),
            amount_with_period_and_space_separator: () => group(cents, 2, ' ', '.'),
            amount_with_apostrophe_separator: () => group(cents, 2, "'", '.'),
          };
          return format.replace(/[{]{2}\s*(\w+)\s*[}]{2}|\[amount\]/, (match, key) =>
            formatters[key] ? formatters[key]() : formatters.amount()
          );
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-section-nav"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-section-nav')) {
    customElements.define(
      'product-section-nav',
      class ProductSectionNav extends HTMLElement {
        connectedCallback() {
          this.items = Array.from(this.querySelectorAll('[data-target]'));
          this.targets = new Map();

          this.items.forEach((item) => {
            const target = document.getElementById(item.dataset.target);
            item.hidden = !target;
            if (target) this.targets.set(target, item.querySelector('a'));
          });

          if (this.items.filter((item) => !item.hidden).length < 2) {
            this.hidden = true;
            return;
          }

          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                this.targets.forEach((link) => link.removeAttribute('aria-current'));
                this.targets.get(entry.target)?.setAttribute('aria-current', 'true');
              });
            },
            { rootMargin: '-30% 0px -60% 0px' }
          );
          this.targets.forEach((_link, target) => this.observer.observe(target));

          this.firstTarget = this.targets.keys().next().value;
          this.onScroll = () => {
            if (this.firstTarget.getBoundingClientRect().top < window.innerHeight * 0.4) return;
            this.targets.forEach((link) => link.removeAttribute('aria-current'));
            this.targets.get(this.firstTarget)?.setAttribute('aria-current', 'true');
          };
          window.addEventListener('scroll', this.onScroll, { passive: true });
          this.onScroll();
        }

        disconnectedCallback() {
          this.observer?.disconnect();
          if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["project-gallery"] && !Shopify.designMode) return;
  try {
    
  // Opens the project image dialog from a card. The native <dialog> traps focus and closes on
  // Escape; the close button and a click on the backdrop also close it. Page scrolling is locked
  // while it is open and focus returns to the card that opened it.
  (() => {
    if (window.projectGalleryDialog) return;
    window.projectGalleryDialog = true;

    const closeDialog = (dialog) => {
      if (dialog?.open) dialog.close();
    };

    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-project-open]');
      if (opener) {
        const dialog = document.getElementById(opener.dataset.projectOpen);
        if (!dialog || typeof dialog.showModal !== 'function') return;
        const image = dialog.querySelector('[data-dialog-image]');
        const placeholder = dialog.querySelector('[data-dialog-placeholder]');
        const hasImage = Boolean(opener.dataset.image);

        image.hidden = !hasImage;
        placeholder.hidden = hasImage;
        if (hasImage) {
          image.src = opener.dataset.image;
          image.alt = opener.dataset.alt || '';
          if (opener.dataset.imageWidth) image.width = Number(opener.dataset.imageWidth);
          if (opener.dataset.imageHeight) image.height = Number(opener.dataset.imageHeight);
        } else {
          image.removeAttribute('src');
        }
        dialog.querySelector('[data-dialog-title]').textContent = opener.dataset.title || '';
        const location = dialog.querySelector('[data-dialog-location]');
        location.textContent = opener.dataset.location || '';
        location.hidden = !opener.dataset.location;
        const notice = dialog.querySelector('[data-dialog-notice]');
        if (notice) notice.hidden = opener.dataset.sample !== 'true';

        dialog.returnFocusTo = opener;
        document.documentElement.classList.add('project-gallery-dialog-open');
        dialog.showModal();
        dialog.querySelector('[data-project-close]').focus();
        return;
      }

      if (event.target.closest('[data-project-close]')) {
        closeDialog(event.target.closest('dialog'));
        return;
      }

      // A click on the dialog element itself (not its panel) is a click on the backdrop
      if (event.target instanceof HTMLDialogElement && event.target.classList.contains('project-gallery__dialog')) {
        closeDialog(event.target);
      }
    });

    document.addEventListener(
      'close',
      (event) => {
        const dialog = event.target;
        if (!(dialog instanceof HTMLDialogElement) || !dialog.classList.contains('project-gallery__dialog')) return;
        document.documentElement.classList.remove('project-gallery-dialog-open');
        if (dialog.returnFocusTo) {
          dialog.returnFocusTo.focus();
          dialog.returnFocusTo = null;
        }
      },
      true
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["project-series-cameras"] && !Shopify.designMode) return;
  try {
    
  // Opens the expert callback dialog. The native <dialog> traps focus and closes on Escape;
  // focus goes back to the button that opened it. Backdrop clicks are ignored so a half-filled
  // form isn't lost by accident.
  (() => {
    if (window.projectSeriesExpertDialog) return;
    window.projectSeriesExpertDialog = true;

    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-expert-open]');
      if (opener) {
        const dialog = document.getElementById(opener.dataset.expertOpen);
        if (!dialog || typeof dialog.showModal !== 'function') return;
        dialog.returnFocusTo = opener;
        dialog.showModal();
        const firstField = dialog.querySelector('.project-series__dialog-form :is(input, textarea, select, a[href])');
        (firstField || dialog.querySelector('.project-series__dialog-close')).focus();
        return;
      }

      const closer = event.target.closest('[data-expert-close]');
      if (closer) closer.closest('dialog')?.close();
    });

    document.addEventListener(
      'close',
      (event) => {
        const dialog = event.target;
        if (dialog instanceof HTMLDialogElement && dialog.returnFocusTo) {
          dialog.returnFocusTo.focus();
          dialog.returnFocusTo = null;
        }
      },
      true
    );
  })();

  } catch(e) { console.error(e); }
})();
})();
